import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization } from "../ApiMethod/ApiMethod";

export const GetTempleRegistrationDetailsBySlug = async (slug) => {
    const url = `${BaseUrl}/GetTempleRegistrationDetailsBySlug?Slug=${slug}`;
    const res = await getApiWithAuthorization(url);

    return res;
};